// extracted by css-extract-rspack-plugin
export default {"PromoSlot":"Jq7Fa"};